import React from 'react';
import { Check } from 'lucide-react';

export const Checkbox = React.forwardRef(({ 
  className = '', 
  checked = false, 
  onCheckedChange,
  disabled = false,
  id,
  ...props 
}, ref) => {
  return (
    <div className="relative inline-flex items-center">
      <input
        type="checkbox"
        id={id}
        ref={ref}
        className="sr-only"
        checked={checked}
        onChange={(e) => onCheckedChange?.(e.target.checked)}
        disabled={disabled}
        {...props}
      />
      <div
        className={`
          w-5 h-5 rounded border-2 flex items-center justify-center cursor-pointer transition-colors
          ${checked 
            ? 'bg-blue-600 border-blue-600' 
            : 'bg-white border-gray-300 hover:border-gray-400'
          }
          ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
          ${className}
        `}
        onClick={() => !disabled && onCheckedChange?.(!checked)}
      >
        {checked && (
          <Check className="h-3 w-3 text-white" strokeWidth={3} />
        )}
      </div>
    </div>
  );
});

Checkbox.displayName = 'Checkbox';